import React, { useState } from "react";
import { IoMdEye } from "react-icons/io";
import { IoMdEyeOff } from "react-icons/io";

const AccountDrawer = ({ onClose }) => {
  const [openItem, setOpenItem] = useState(null);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const toggleItem = (index) => {
    setOpenItem(openItem === index ? null : index);
  };

  const accountItems = [
    { label: "Name", value: "Chris Banks", inputType: "text" },
    { label: "Email", value: "c***s@nxtrlv.io", inputType: "email" },
    { label: "Password", value: "********", inputType: "password" },
    {
      label: "Delete Account",
      value: (
        <span className="font-space-grotesk text-[#1E0A1E] font-normal leading-[17px] text-[14px]">
          To delete your account please contact{' '}
          <span className="underline">help@famjam.com</span>
        </span>
      )
    },
  ];

  return (
    <div className="min-h-screen">
      <div className="w-full flex items-center" style={{
        background: "linear-gradient(to bottom, rgba(225, 225, 225, 1) 0%, rgba(225, 225, 225, 0) 100%)",
        padding: "35px 21px 26px"
      }}>
        <button
          onClick={onClose}
          className="absolute top-[34px] bg-white rounded-full p-1 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-400"
            fill="none"
            viewBox="0 0 26 26"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <h1 className="text-[20px] leading-[20px] font-normal font-young-serif text-center mx-auto">
          Account
        </h1>
      </div>

      <div className="p-6 pt-0">
        <div className="mx-1 border-t border-[#EEEEEE]" />
        {accountItems.map((item, index) => (
          <div key={index} className="border-b border-[#EEEEEE]">
            <button
              onClick={() => toggleItem(index)}
              className={`w-full flex justify-between items-center py-4 pb-3 px-6 text-gray-800 ${
                openItem === index ? 'text-black' : 'text-gray-500'
              }`}
            >
              <div className="flex flex-col items-start gap-1">
                <span className="font-normal leading-[16px] font-young-serif">{item.label}</span>
                {item.label !== "Delete Account" && (
                  <span className="text-[#1E0A1E] font-normal font-space-grotesk text-[14px]">
                    {item.value}
                  </span>
                )}
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className={`h-6 w-6 flex-shrink-0 ${
                  openItem === index ? "text-[#0F172A] rotate-90" : "text-[#0F172A]"
                } transform transition-transform`}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
            {openItem === index && (
              <div className="pb-8 px-6">
                {item.label === "Delete Account" ? (
                  <p className="text-[#1E0A1E] font-space-grotesk text-[14px]">
                    {item.value}
                  </p>
                ) : item.label === "Password" ? (
                  <>
                    <div className="mb-4">
                      <label className="block text-[14px] font-medium text-[#1E0A1E] mb-2 font-space-grotesk">
                        Current password
                      </label>
                      <div className="relative">
                        <input
                          type={showCurrentPassword ? "text" : "password"}
                          defaultValue="H4z4rd1981"
                          className="w-full border focus:outline-none focus:ring-2 focus:ring-purple-500 rounded-full p-2 pr-10 text-[#1E0A1E] text-[14px] font-normal font-space-grotesk"
                        />
                        <span className="text-[12px] text-[#929292] font-space-grotesk">Need a new password?</span>
                        <button
                          type="button"
                          onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                          className="absolute right-3 top-3 text-gray-400"
                        >
                          {showCurrentPassword ? <IoMdEyeOff size={20} /> : <IoMdEye size={20} color="#0F172A" />}
                        </button>
                      </div>
                    </div>

                    <div className="mb-4">
                      <label className="block text-sm font-medium text-[#1E0A1E] mb-2 font-space-grotesk">
                        New password
                      </label>
                      <div className="relative">
                        <input
                          type={showNewPassword ? "text" : "password"}
                          className="focus:outline-none focus:ring-2 focus:ring-purple-500 w-full border rounded-full p-2 pr-10 text-[#1E0A1E] text-[14px] font-normal font-space-grotesk"
                        />
                        <button
                          type="button"
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          className="absolute right-3 top-3 text-gray-400"
                        >
                          {showNewPassword ? <IoMdEyeOff size={20} /> : <IoMdEye size={20} color="#0F172A" />}
                        </button>
                      </div>
                    </div>

                    <div className="mb-4">
                      <label className="block text-sm font-medium text-[#1E0A1E] mb-2 font-space-grotesk">
                        Confirm password
                      </label>
                      <div className="relative">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          className="w-full border rounded-full p-2 pr-10 focus:outline-none focus:ring-2 focus:ring-purple-500 text-[#1E0A1E] text-[14px] font-normal font-space-grotesk"
                        />
                        <button
                          type="button"
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          className="absolute right-3 top-3 text-gray-400"
                        >
                          {showConfirmPassword ? <IoMdEyeOff size={20} /> : <IoMdEye size={20} color="#0F172A" />}
                        </button>
                      </div>
                    </div>

                    <button className="bg-[#1E0A1E] text-[#EEEEEE] font-space-grotesk text-[16px] font-medium py-2 px-6 rounded-full shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]">
                      Save
                    </button>
                  </>
                ) : (
                  <>
                    <input
                      type={item.inputType}
                      defaultValue={item.value}
                      className="w-full border rounded-full p-2 mb-3 focus:outline-none focus:ring-2 focus:ring-purple-500 text-[#1E0A1E] text-[14px] font-normal font-space-grotesk"
                    />
                    <button className="bg-[#1E0A1E] text-[#EEEEEE] font-space-grotesk text-[16px] font-medium py-2 px-6 rounded-full shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]">
                      Save
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccountDrawer;